import { render, staticRenderFns } from "./SignInView.vue?vue&type=template&id=473ca1f8"
import script from "./SignInView.vue?vue&type=script&lang=ts"
export * from "./SignInView.vue?vue&type=script&lang=ts"
import style0 from "./SignInView.vue?vue&type=style&index=0&id=473ca1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports